// A Wrapper for the <FormControl>, <InputLabel>, <Error> and the Stripe <*Element>.
// Similar to Material UI's <TextField>. Handles focused, empty and error state
// to correctly show the floating label and error messages etc.

import React, { useState } from 'react';
import StripeInput from './StripeInput';
import { FormControl, InputLabel, Input } from '@material-ui/core';

export const StripeElementWrapper = ({ component, label }) => {
  const [focused, setFocused] = useState(false);
  const [empty, setEmpty] = useState(true);
  const [error, setError] = useState(null);

  const onBlur = () => setFocused(false);
  const onFocus = () => setFocused(true);

  const onChange = changeObj => {
    console.log('onChangeInput', changeObj);
    setError(changeObj.error);
    setEmpty(changeObj.empty);
  };
  return (
    <div>
      <FormControl fullWidth margin="normal">
        <InputLabel focused={focused} shrink={focused || !empty} error={!!error}>
          {label}
        </InputLabel>
        <Input fullWidth inputComponent={StripeInput} inputProps={{ component, onChange, onFocus, onBlur }} />
      </FormControl>
    </div>
  );
};
